import { render, staticRenderFns } from "./VacationCategoryView.vue?vue&type=template&id=79ca6fe2"
import script from "./VacationCategoryView.vue?vue&type=script&lang=js"
export * from "./VacationCategoryView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports